import QuoteCentered from './QuoteCentered';
const VARIANTS = { 'quote-centered': QuoteCentered };
export default function QuoteSection({ section, data, theme, settings }) {
  const Variant = VARIANTS[section.variant] || QuoteCentered;
  return <Variant section={section} data={data} theme={theme} settings={settings} />;
}
